<div fxLayout="column" class="percentage-gauge">
    <div fxLayout="row"
        [style.width]="'100%'"
        [style.background-color]="'#e0e0e0'"
        [style.height]="'25px'">
        <span 
            [style.display]="'inline-block'"
            [style.background-color]="gaugeColor"
            [style.height]="'100%'"
            [style.width]="gaugePercentageAsString()">
        </span>
    </div>
    <div fxLayout="row">
      <span class="percentage-gauge-label">{{gaugePercentageAsString()}}</span>
    </div>
</div>

